import createIcon from '../../createIcon';

/**
 * @component @name TextRotationAngleup
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC40ODk2OSAzLjYwNDk4TDMuNDI5NjkgNC42NjQ5OEw3Ljg0OTY5IDE1Ljc5NUw5LjMyOTY5IDE0LjMxNUw4LjQwOTY5IDEyLjEyNUwxMS45NDk3IDguNTg0OThMMTQuMTM5NyA5LjUwNDk4TDE1LjYxOTcgOC4wMjQ5OEw0LjQ4OTY5IDMuNjA0OThaTTcuNTc5NjkgMTAuNDA1TDUuMzU5NjkgNS41MzQ5OEwxMC4yMjk3IDcuNzY0OThMNy41Nzk2OSAxMC40MDVaTTIwLjU2OTcgOC43MjQ5OEgxNi4zMjk3TDE3LjczOTcgMTAuMTM1TDguODk5NjkgMTguOTc1TDEwLjMxOTcgMjAuMzk1TDE5LjE1OTcgMTEuNTU1TDIwLjU2OTcgMTIuOTY1VjguNzI0OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextRotationAngleup = createIcon('TextRotationAngleup', [
  [
    'path',
    {
      d: 'M4.48969 3.60498L3.42969 4.66498L7.84969 15.795L9.32969 14.315L8.40969 12.125L11.9497 8.58498L14.1397 9.50498L15.6197 8.02498L4.48969 3.60498ZM7.57969 10.405L5.35969 5.53498L10.2297 7.76498L7.57969 10.405ZM20.5697 8.72498H16.3297L17.7397 10.135L8.89969 18.975L10.3197 20.395L19.1597 11.555L20.5697 12.965V8.72498Z',
      key: '5j6q01',
    },
  ],
]);

export default TextRotationAngleup;
